import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { routes } from "./routes";
import { toastConfig } from "./config/toastConfig";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./components/Layout";
import MinimalLayout from "./components/MinimalLayout";
import BlogLayout from "./components/BlogLayout";
import { Analytics } from "@vercel/analytics/react"
import "./styles/app.scss";
import { init } from "emailjs-com";

// Initialize EmailJS with environment variable
init(process.env.REACT_APP_EMAILJS_USER_ID);

const App = () => {
  const getLayout = (path, element) => {
    if (path === "/") return element;
    if (path === "/nutrition-coaching") return <MinimalLayout>{element}</MinimalLayout>;
    if (path.startsWith("/blog")) return <BlogLayout>{element}</BlogLayout>;
    return <Layout>{element}</Layout>;
  };

  return (
    <ErrorBoundary>
      <BrowserRouter basename="/">
        <Toaster {...toastConfig} />
        <Analytics />
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={getLayout(route.path, route.element)}
            />
          ))}
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
